<template>
  <div class="index">
    <div class="common_mbx">
      您当前的位置：<router-link to='/index' tag='span'>首页</router-link> ><router-link to='/our' tag='span'> 我们</router-link> > 联系我们
    </div>
    <div class="common_wrap">
      <img src="../../static/images/contact.jpg" class="top_banner">
      <div class="about_lists clearfix">
        <div class="about_item contact">
          <p class="about_title">
            <span class="num address"></span>
            <span>帝景价值</span>
          </p>
          <div class="about_text">
            上海帝景卫浴设备有限公司<br>
            地址( ADD )：上海市徐汇区桂箐路7号G7-B201<br>
            电话( TEL )：021-52366166 52366178<br>
            网址：http://dking.vapps.me/dist/index.html<br>
            电子邮件( E-MAIL )：<a href='mailto:wellness@dkingsh.com'>wellness@dkingsh.com</a><br>
            微信公众号：dkingsh<br>
          </div>
        </div>
        <div class="contact_code">
          <img src="../../static/images/contact_code.png">
          <img src="../../static/images/contact_tmall.png">
          <router-link to="/leavemsg">
          <div class="leave_msg">给我们留言</div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return{
      isX:false
    }
  },
  watch:{
    '$route':function(to,from){
      //this.getconfig()
    }
  },
  mounted:function(){
  }
}
</script>

<style scoped>

 .common_wrap{
  width: 1200px;
  margin: 0 auto;
 }
 .top_banner{
  margin-bottom: 72px;
 }
 .about_title{
  min-width: 98px;
  height: 42px;
  line-height: 42px;
  border-radius: 4px;
  background-color: #f8f7f7;
  color: #000000;
  font-size: 18px;
  margin-bottom: 30px;
  padding-right: 10px;
  display: inline-block;
 }
 .about_item{
  margin-bottom: 46px;
 }
 .about_item.contact{
  width: 450px;
  float: left;
 }
 .num{
  width: 32px;
  height: 32px;
  line-height: 32px;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
  text-align: center;
  background-color: #3478f7;
  display: inline-block;
  margin-left: 7px;
  vertical-align: middle;
 }
 .num img{
  margin-top: 4px;
 }
 .num.address{
  background-image: url(/static/images/address.jpg);
  background-repeat: no-repeat;
  background-position: center;
 }
 .about_text{
  font-size: 14px;
  color: #000000;
  line-height: 200%;
 }
 .about_text a{
  color: #000000
 }
 .contact_code img{
  margin-right: 57px;
 }
 .leave_msg{
  font-size: 14px;
  color: #383838;
  width: 134px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 4px;
  border: 1px solid #e4e4e4;
  float: right;
  margin-right: 135px;
  margin-top: 125px;
 }
</style>


// WEBPACK FOOTER //
// src/components/contact.vue